/**
 * Brand photography slots (M18).
 *
 * The files in `public/img/` are the group site's own desktop derivatives, kept under their
 * original names so each one stays traceable to the asset biaoperasyonel.com serves. Those
 * names carry a content hash and say nothing about where the image is used — and two of the
 * drone shots differ only in the middle digits, which is exactly the pair a hand-typed
 * filename would swap. So the call sites name the *slot* and this map holds the filename:
 * replacing a photograph is one edit here, not a search across four routes.
 *
 * Every consumer layers the image **under** the navy gradient (`PageHero`, `LoginPage`), so
 * an entry that points at a missing file costs nothing — the band renders as it did before
 * the photography landed. See `docs/ui-design/bidder-photography.md`.
 */
export const PHOTOS = {
  /** Top-down drone shot of the yard — public showcase. */
  yardAerial: 'dji_20260515123843_0013_d-6a0c4fc268908-desktop.webp',
  /** Three-quarter drone shot, yellow bay lines — `/me` and `/me/bids`. */
  yardWide: 'dji_20260515124259_0021_d-6a0ec2f18ed4d-desktop.webp',
  /** Aerial rows of new vehicles — `/membership`. */
  fleetRows: 'aerial-top-view-rows-of-new-cars-parked-in-distrib-2026-01-06-10-51-13-utc-69986d6b794f2-desktop.webp',
  /** Grille close-up with the biaoperasyonel.com plate — login. */
  brandPlate: 'dsc03745-6a0ec35dcf379-desktop.webp',
} as const;
